export const ENVIRONMENTS = 'ENVIRONMENTS';
export const API_BASE_URL = 'API_BASE_URL';
